

























































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { UserService } from '@/api'

@Component({ components: {} })
export default class Index extends Vue {
  public email = ''
  public password = ''
  public authorized = false
  public calledAuth = false
  public calledLogout = false

  public mounted (): void {
    const token = this.$cookies.get('randomUserId')

    if (token === null || typeof token !== 'string') {
      return
    }

    this.authorized = true
  }

  public auth (): void {
    UserService.authUser({ requestBody: { email: this.email, password: this.password } }).then((res) => {
      this.authorized = res.authorized
      this.calledLogout = false
    }).finally(() => {
      this.calledAuth = true
    })
  }

  public logout (): void {
    UserService.logoutUser().then((res) => {
      this.authorized = !res.loggedout
      this.calledAuth = false
    }).finally(() => {
      this.calledLogout = true
    })
  }
}
